import fetch from '@/plugin/axios'

// 查询信息列表
export function getNewsList (query) {
  return fetch({
    url: '/api/common/message-tpl/list',
    method: 'Post',
    data: query
  })
}

// 修改
export function getNewsUpdate (id, query) {
  return fetch({
    url: `/api/common/message-tpl/update/${id}`,
    method: 'Post',
    data: query
  })
}
// 跳转类型
export function getTypeLits () {
  return fetch({
    url: '/api/common/skip-type/list',
    method: 'Get'
  })
}
// 跳转类型列表
export function getTypePage () {
  return fetch({
    url: '/api/common/skip-type/page',
    method: 'Get'
  })
}

// 新增跳转类型
export function getTypeAdd (data) {
  return fetch({
    url: '/api/common/skip-type/add',
    method: 'Post',
    data: data
  })
}

// 修改跳转类型
export function getTypeUpdate (id, data) {
  return fetch({
    url: `/api/common/skip-type/update/${id}`,
    method: 'Post',
    data: data
  })
}

// 类型列表
export function getUserList () {
  return fetch({
    url: '/api/common/message-user/list',
    method: 'Get'
  })
}

// 类型修改
export function getUserUpdate (id, query) {
  return fetch({
    url: `/api/common/message-user/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 发送信息
export function getSend (query) {
  return fetch({
    url: '/api/common/sys-message/send',
    method: 'Post',
    data: query
  })
}
